module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-4.7860423f.svg";